import { Component, EventEmitter, Output } from '@angular/core'
import { ButtonColor, ModalComponent, ModalType } from '@ftr/foundation'

@Component({
  standalone: true,
  selector: 'ftr-delete-hearing-annotation-modal',
  templateUrl: './delete-hearing-annotation-modal.component.html',
  imports: [ModalComponent],
})
export class DeleteHearingAnnotationModalComponent {
  @Output() onDelete = new EventEmitter<void>()

  readonly modalType = ModalType
  readonly buttonColor = ButtonColor
}
